export const MOBILE_WIDTH = 1080